var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"residential-badge",class:_vm.view.cls,attrs:{"title":_vm.view.hint}},[_c('i',{staticClass:"mdi",class:_vm.view.icon}),_vm._v(" "+_vm._s(_vm.view.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }